import { render, staticRenderFns } from "./Readytogetstarted.vue?vue&type=template&id=1439abbf&scoped=true&"
import script from "./Readytogetstarted.vue?vue&type=script&lang=js&"
export * from "./Readytogetstarted.vue?vue&type=script&lang=js&"
import style0 from "./Readytogetstarted.vue?vue&type=style&index=0&id=1439abbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439abbf",
  null
  
)

export default component.exports